<template>
  <div class="wrapper relative pt-12 pb-24 px-4 sm:px-8" id="how-it-works">
    <div class="max-w-(--max-width) mx-auto">
      <div
        class="lg:max-w-10/12 mx-auto bg-white rounded-lg shadow-lg overflow-hidden p-12 z-[1] relative">
        <div class="mb-10">
          <p
            class="text-(--brand-primary) text-xs uppercase tracking-wider mb-5 text-center font-medium">
            HOW IT WORKS</p>
          <h2 class="text-2xl lg:text-4xl font-medium text-center mb-4.5">The fastest way to check
            if you
            qualify
            for a claim</h2>
          <p class="text-center text-lg lg:text-xl mb-5">
            Been impacted by a consumer-related car issue?<br>
            Claims For Cars makes the claims process simple and stress-free.
          </p>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div class="flex flex-col items-center">
            <div class="w-16 h-16 flex items-center justify-center mb-4">
              <img src="@/assets/images/car.svg" class="w-16" alt="">
            </div>
            <h3 class="font-medium text-(--brand-primary) text-2xl mb-3">Enter your REG</h3>
            <p class="text-base font-medium mb-4 text-center">Enter your vehicle registration for a
              free
              eligibility check</p>
          </div>

          <div class="flex flex-col items-center">
            <div class="w-16 h-16 flex items-center justify-center mb-4">
              <img src="@/assets/images/eligibility.svg" class="w-16" alt="">
            </div>
            <h3 class="font-medium text-(--brand-primary) text-2xl mb-3">Check your eligibility</h3>
            <p class="text-base font-medium mb-4 text-center">Discover which car claims<br>your
              vehicle
              qualifies
              for</p>
          </div>

          <div class="flex flex-col items-center">
            <div class="w-16 h-16 flex items-center justify-center mb-4">
              <img src="@/assets/images/money.svg" class="w-16" alt="">
            </div>
            <h3 class="font-medium text-(--brand-primary) text-2xl mb-3">Start your Claim</h3>
            <p class="text-base font-medium mb-4 text-center">Start your claim and get the
              compensation you
              deserve</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.wrapper::before,
.wrapper::after {
  display: block;
  content: '';
  width: 100%;
  height: 50%;
  top: 0;
  left: 0;
  position: absolute;
  z-index: 0;
}

.wrapper::after {
  top: 50%;
  background: var(--brand-primary);
}
</style>
<script setup lang="ts">
</script>
